import { getAuthUserState } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import * as Sentry from '@sentry/nextjs'
import React from 'react'

export const useAuthUser = () => {
  const client = useGyymClient()

  const {
    data: authUser,
    mutate,
    isValidating,
  } = useGyymSWR(client.auth.user.get, {
    revalidateOnMount: false,
  })

  React.useEffect(() => {
    if (!authUser) return

    Sentry.setUser({
      id: `${authUser.id}`,
    })
  }, [authUser])

  const revalidate = React.useCallback(async () => {
    const newUser = await client.auth.user.get()
    await mutate(newUser, { revalidate: false })
    return newUser
  }, [mutate, client])

  const authUserState = getAuthUserState(authUser)

  return {
    authUser,
    revalidate,
    mutate,
    isLoading: !authUser && isValidating,
    isValidating,
    ...authUserState,
  }
}
